import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fdb9209"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex order-status" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { key: 1 }

import { t } from '@/plugins/i18n'
import { ref, reactive, toRefs, computed, nextTick, onMounted } from 'vue'
import STable from '@/components/Table/index.vue'
import AppLink from '@/components/common/AppLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { queryAbnormalOrder, isShowShopifyTitleApi, countAbnormalOrderCount, abnormalQueryGroup } from '@/apis/order'
import { getJapanTime, clearForm, setStartDateTime, setEndDateTime } from '@/util/common'
import {
  d2cProblemHandlingColumns0,
  b2bProblemHandlingColumns0,
  d2cProblemHandlingColumns1,
  b2bProblemHandlingColumns1,
  problemHandlingTableConfig,
  customerOperateTypeDict
} from './data'
import ADialog from './ADialog.vue'
import ADialogDrawer from './ADialog_drawer.vue'
import GoodsLink from '@/components/common/GoodsLink.vue'
import { productStatsEnum, setProdcutLink } from '../data'
import ProductSku from '../components/ProductSku.vue'
import { useRtfix, isD2C, useSite, getCustomerShopPlatform } from '@/store'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import dblclick from '@/components/BatchSearch/index'
import BatchSearch from '@/components/BatchSearch/index.vue'
import HandelStatus from './components/HandelStatus.vue'
import AbnormalTable from './components/AbnormalTable.vue'
import bus from '@/util/useBus'
import Cookie from 'js-cookie'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const route = useRoute()

const form = reactive({
  abnormalOrderType: 1,
  customerOperateStatus: 1,
  productSku: '',
  platformOrderNo: '',
  createTimeStart: '',
  createTimeEnd: '',
  customerOrderNo: '',
  orderName: ''
})

const onlyRead = ref(false)
// 消息 订单列表跳转
if (route.query.platformOrderNo) {
  form.platformOrderNo = route.query.platformOrderNo
}
if (route.query.productSku) {
  form.productSku = route.query.productSku
}
// 1未处理 0 已处理
if (route.query.customerOperateStatus) {
  form.customerOperateStatus = Number(route.query.customerOperateStatus)
}
const resetForm = () => {
  const customerOperateStatus = form.customerOperateStatus
  clearForm(form)
  isBatchSearch.value = false
  form.abnormalOrderType = 1
  form.customerOperateStatus = customerOperateStatus
  refreshTable(true)
}

const pageData = ref({
  page: 1,
  limit: 10
})

const filterData = computed(() => {
  return {
    ...form,
    createTimeStart: setStartDateTime(form.createTimeStart),
    createTimeEnd: setEndDateTime(form.createTimeEnd)
  }
})

const searchDate = computed({
  get: () => [form.createTimeStart, form.createTimeEnd],
  set: (newVal) => { [form.createTimeStart, form.createTimeEnd] = newVal ?? [] }
})

const switchStatus = (status: number) => {
  if (form.customerOperateStatus === status) return
  form.customerOperateStatus = status
  isBatchSearch.value = false
  refreshTable(true)
}

const rowItem = ref({})
const ProblemVisible = ref(false)
const openProblemVisible = (row: any) => {
  ProblemVisible.value = true
  onlyRead.value = form.customerOperateStatus === 0
  rowItem.value = row
}

const showOrderNum = (row: any) => {
  return row.orderItemStatusInfoDTO?.orderQuantity ?? 0
}

const showOrderStatus = (row: any) => {
  const list = []
  for (const v of (row.orderItemStatusInfoDTO?.orderItemStatusList || [])) {
    list.push(`${productStatsEnum[v.orderItemStatus]}(${v.commodityQuantity})`)
  }
  return list
}

const store = useStore()
const notProcessedOrder = computed(() => store.getters.notProcessedOrder)

const dataListener = async () => {
  if (form.customerOperateStatus === 1) {
    const { data } = await countAbnormalOrderCount({})
    // totalOrderCount
    store.commit('route/notProcessedOrder', data)

    nextTick(() => {
      STableRef.value.expandAllChange()
    })
  }
}

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 10
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
expose({
  refreshTable
})

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearchProblemHandling', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    abnormalOrderType: form.abnormalOrderType,
    customerOperateStatus: form.customerOperateStatus
  }
  refreshTable(true)
})

const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}
const dblclickFn = (str: string) => {
  console.log(123123)
  form.customerOrderNo = ''
  switch (str) {
    case 'customerOrderNoList':
      form.customerOrderNo = ''
      break
  }
  dblclick(str)
}

const isStoreApi = computed(() => store.getters.shopInfo?.customerShopPlatform === 3)
// 是否产生过shopify订单
const isShopify = ref(false)
isShowShopifyTitleApi().then((res: any) => {
  isShopify.value = res.data?.isSubscription || isStoreApi.value
})

const columns = computed(() => {
  let list = form.customerOperateStatus ? (isD2C() ? d2cProblemHandlingColumns1 : b2bProblemHandlingColumns1) : (isD2C() ? d2cProblemHandlingColumns0 : b2bProblemHandlingColumns0)
  if (isD2C() && !isShopify.value) {
    list = list.filter((i: any) => i.prop !== 'orderName')
  }
  return list.map((i) => {
    if (i.prop === 'orderName') {
      i.label = t('订单') + `(${getCustomerShopPlatform()})`
    }
    return i
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["order-search flex-col", _unref(useSite)()])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_badge, {
          value: _unref(notProcessedOrder).abnormalOrderCount,
          hidden: _unref(notProcessedOrder)?.abnormalOrderCount <= 0
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass({ active: _unref(form).customerOperateStatus === 1 }),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (switchStatus(1)))
            }, _toDisplayString(_unref(t)('未处理')), 3)
          ]),
          _: 1
        }, 8, ["value", "hidden"]),
        _createElementVNode("p", {
          style: {"margin-left":"62px"},
          class: _normalizeClass({ active: _unref(form).customerOperateStatus === 0 }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (switchStatus(0)))
        }, _toDisplayString(_unref(t)('已处理')), 3)
      ]),
      _createVNode(_component_el_form, {
        inline: true,
        model: _unref(form)
      }, {
        default: _withCtx(() => [
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _unref(t)('客户订单编号')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).customerOrderNo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).customerOrderNo) = $event)),
                    onDblclick: _cache[3] || (_cache[3] = ($event: any) => {_unref(form).customerOrderNo = ''; _unref(dblclick)('customerOrderNoList')}),
                    placeholder: _unref(t)('双击批量搜索'),
                    style: {"width":"220px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_unref(isD2C)() && isShopify.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: _unref(t)('订单') + `(${_unref(getCustomerShopPlatform)()})`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).orderName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).orderName) = $event)),
                    onDblclick: _cache[5] || (_cache[5] = ($event: any) => {_unref(form).orderName = ''; _unref(dblclick)('customerOrderNoList')}),
                    placeholder: _unref(t)('双击批量搜索'),
                    style: {"width":"220px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (!_unref(isD2C)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                label: _unref(t)('订单标题')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).customerOrderNo,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).customerOrderNo) = $event)),
                    onDblclick: _cache[7] || (_cache[7] = ($event: any) => {_unref(form).customerOrderNo = ''; _unref(dblclick)('customerOrderNoList')}),
                    placeholder: _unref(t)('双击批量搜索'),
                    style: {"width":"220px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('平台商品SKU')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).productSku,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).productSku) = $event)),
                onDblclick: _cache[9] || (_cache[9] = ($event: any) => {_unref(form).productSku = ''; _unref(dblclick)('productSkuList')}),
                placeholder: _unref(t)('双击批量搜索'),
                style: {"width":"220px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('THE CKB订单编号')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).platformOrderNo,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).platformOrderNo) = $event)),
                onDblclick: _cache[11] || (_cache[11] = ($event: any) => {_unref(form).platformOrderNo = ''; _unref(dblclick)('platformOrderNoList')}),
                placeholder: _unref(t)('双击批量搜索'),
                style: {"width":"220px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('最新问题时间')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _unref(searchDate),
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": _unref(t)('开始时间'),
                "end-placeholder": _unref(t)('结束时间'),
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "warning",
                onClick: search
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[15] || (_cache[15] = ($event: any) => ((pageData).value = $event)),
        isImmediatelyExec: false,
        api: _unref(abnormalQueryGroup),
        filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
        columns: _unref(columns),
        tableConfig: { ..._unref(problemHandlingTableConfig) },
        onDataListener: dataListener
      }, {
        customerOrderNo: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.customerOrderNo || '-'), 1)
        ]),
        orderName: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.orderName || '-'), 1)
        ]),
        platformOrderNo: _withCtx(({ row }) => [
          _createElementVNode("div", {
            onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
          }, [
            (row.platformOrderId)
              ? (_openBlock(), _createBlock(AppLink, {
                  key: 0,
                  to: _unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId } })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.platformOrderNo), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.platformOrderNo), 1))
          ])
        ]),
        productSku: _withCtx(({ row }) => [
          row
            ? (_openBlock(), _createBlock(ProductSku, {
                key: 0,
                row: row
              }, null, 8, ["row"]))
            : _createCommentVNode("", true)
        ]),
        productProp: _withCtx(({ row }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productProp || '').split(';'), (prop) => {
            return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
          }), 128))
        ]),
        problemGenerationTime: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.cancelApplyTime), 1)
        ]),
        shoppingInfo: _withCtx(({ row }) => [
          _createElementVNode("div", {
            class: "flex-ter",
            onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(GoodsLink, {
              goods: row,
              class: "fx-1"
            }, {
              default: _withCtx(() => [
                _createVNode(ShoppingPreview, {
                  image: row.productImg || '',
                  name: row.productName || ''
                }, null, 8, ["image", "name"])
              ]),
              _: 2
            }, 1032, ["goods"])
          ])
        ]),
        createTime: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.maxCreateTime)), 1)
        ]),
        customerOperateType: _withCtx(({ row }) => [
          _createVNode(HandelStatus, { rowItem: row }, null, 8, ["rowItem"])
        ]),
        orderNum: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(showOrderNum(row)), 1)
        ]),
        orderStatus: _withCtx(({ row }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showOrderStatus(row), (v) => {
            return (_openBlock(), _createElementBlock("p", { key: v }, _toDisplayString(v), 1))
          }), 128))
        ]),
        expand: _withCtx(({ scope }) => [
          (scope.$index > -1)
            ? (_openBlock(), _createBlock(AbnormalTable, {
                key: 0,
                customerOperateStatus: _unref(form).customerOperateStatus,
                details: scope.row.details,
                onOpen: openProblemVisible
              }, null, 8, ["customerOperateStatus", "details"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["page-data", "api", "filterData", "columns", "tableConfig"]),
      _createVNode(BatchSearch, { title: "ProblemHandling" })
    ]),
    _createVNode(ADialogDrawer, {
      title: _unref(t)('问题联络'),
      visible: ProblemVisible.value,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((ProblemVisible).value = $event)),
      rowItem: rowItem.value,
      onRefresh: refreshTable,
      onlyRead: onlyRead.value
    }, null, 8, ["title", "visible", "rowItem", "onlyRead"])
  ]))
}
}

})